import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import AuthProviderSteps from './AuthProviderSteps';
import { useIntl } from 'react-intl';
import Modal from './Modal';
import Icon from './Icon';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import styles from './OnboardingModal.module.scss';
export default function OnboardingModal(param) {
    var channel = param.channel, isOpen = param.isOpen, onClose = param.onClose;
    var intl = useIntl();
    return /*#__PURE__*/ _jsx(Modal, {
        titleIcon: /*#__PURE__*/ _jsx(Icon, {
            icon: faCheckCircle,
            className: styles.checkIcon
        }),
        isOpen: isOpen,
        title: intl.formatMessage({
            id: "LOq5yM",
            defaultMessage: [
                {
                    type: 0,
                    value: "Setting Up Nightbot"
                }
            ]
        }),
        onClose: onClose,
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.modalDescription,
            children: /*#__PURE__*/ _jsx(AuthProviderSteps, {
                channel: channel
            })
        })
    });
}
